<template>
  <div id="externalLogin">
    <div class="container">
      <div class="register_login_right ">
        <img
          src="../assets/images/login/ico-close.png"
          alt=""
          class="close1 pointer"
          @click="coloseDia"
        />
        <img
          v-if="forgetShow"
          src="../assets/images/login/ico-arrowleft.png"
          @click="openForgetShow"
          class="back1 pointer"
        />
        <img
          v-if="resetShow"
          src="../assets/images/login/ico-arrowleft.png"
          @click="openResetShow"
          class="back1 pointer"
        />

        <!-- 手机号码验证码登录-->
        <div
          class="register_form"
          v-show="
            !loginByAccountShow && !wxLoginShow && !forgetShow && !resetShow
          "
        >
          <div class="taskTab ">
            <div
              class="taskTabItem pointer"
              :class="!loginByAccountShow ? 'taskTabActive' : ''"
              @click="
                wxLoginShow = false;
                loginByAccountShow = false;
              "
            >
              短信登录
              <div class="tabLine" v-if="!loginByAccountShow"></div>
            </div>
            <div
              class="taskTabItem loginByAccountShow pointer"
              :class="loginByAccountShow ? 'taskTabActive' : ''"
              @click="
                wxLoginShow = false;
                loginByAccountShow = true;
              "
            >
              密码登录
              <div class="tabLine" v-if="loginByAccountShow"></div>
            </div>
          </div>
          <div class="text-R des_img">
            <img
              src="../assets/images/login/img-loginchange-saoyisao.png"
              @click="wxLoginShow = true"
              class=" pointer"
            />
          </div>
          <div class="register_div">
            <div class="login_input pointer">
              <el-input
                auto-complete="new-password"
                @input="formValidate('mobilePhone')"
                autocomplete="new-password"
                :disabled="mobilePhoneDisabled"
                maxlength="20"
                v-model="phoneModeObj.mobilePhone"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </div>
            <div class="password validcode login_input pointer">
              <el-input
                type="text1"
                autocomplete="off"
                maxlength="6"
                v-model="phoneModeObj.validCode"
                readonly
								onfocus="this.removeAttribute('readonly')"
                placeholder="请输入短信验证码"
								@keyup.enter.native="loginByMobile()"
              ></el-input>
              <button class="valid_btn pointer font-16" @click="sendValidClick" :class="jyPhone1?'bs':''">
                {{ sendValidBtnText }}
              </button>
            </div>
            <div class="text-C font-14 forgetPw"></div>
            <div class="userAgreement1 font-14">
              <van-checkbox v-model="userAgreementCheck" @click="clickBox">
                {{ $t("login.tip1") }}
                <span class="protocol" @click.stop="openProtocol">{{
                  $t("login.tip2")
                }}</span
                >{{ $t("login.tip3")
                }}<span class="protocol" @click.stop="openProtocol1">{{
                  $t("login.tip4")
                }}</span>
              </van-checkbox>
            </div>
            <button
              :class="
                phoneModeObj.mobilePhone && phoneModeObj.validCode
                  ? ''
                  : 'disabled-btn'
              "
              :disabled="!(phoneModeObj.mobilePhone && phoneModeObj.validCode)"
              class=" login_btn "
              @click="loginByMobile()"
            >
              登 录
            </button>
          </div>
        </div>

        <!-- 账号密码登录-->
        <div
          class="register_form"
          v-show="
            loginByAccountShow && !wxLoginShow && !forgetShow && !resetShow
          "
        >
          <div class="taskTab ">
            <div
              class="taskTabItem pointer"
              :class="!loginByAccountShow ? 'taskTabActive' : ''"
              @click="
                wxLoginShow = false;
                loginByAccountShow = false;
              "
            >
              短信登录
              <div class="tabLine" v-if="!loginByAccountShow"></div>
            </div>
            <div
              class="taskTabItem loginByAccountShow pointer"
              :class="loginByAccountShow ? 'taskTabActive' : ''"
              @click="
                wxLoginShow = false;
                loginByAccountShow = true;
              "
            >
              密码登录
              <div class="tabLine" v-if="loginByAccountShow"></div>
            </div>
          </div>
          <div class="text-R des_img">
            <img
              src="../assets/images/login/img-loginchange-saoyisao.png"
              @click="wxLoginShow = true"
              class=" pointer"
            />
          </div>
          <div class="register_div">
            <div class="login_input pointer">
              <el-input
                auto-complete="new-password"
                autocomplete="new-password"
                maxlength="50"
                v-model="emailModeObj.email"
                placeholder="请输入账号/邮箱/手机号"
                clearable
              ></el-input>
            </div>
            <div class="login_input password pointer">
              <el-input
                auto-complete="new-password"
                autocomplete="new-password"
                type="password"
                maxlength="50"
                v-model="emailModeObj.password"
                placeholder="请输入密码"
                clearable
								@keyup.enter.native="loginByAccount()"
              ></el-input>
            </div>
            <div
              class="text-C font-14 forgetPw "
              
            >
              <span @click="openForgetShow" class="pointer">忘记密码</span>
            </div>

            <div class="userAgreement1  font-14">
              <van-checkbox v-model="userAgreementCheck" @click="clickBox">
                {{ $t("login.tip1") }}

                <span class="protocol" @click.stop="openProtocol">{{
                  $t("login.tip2")
                }}</span
                >{{ $t("login.tip3")
                }}<span class="protocol" @click.stop="openProtocol1">{{
                  $t("login.tip4")
                }}</span>
              </van-checkbox>
            </div>
            <button
              :class="
                emailModeObj.email && emailModeObj.password
                  ? ''
                  : 'disabled-btn'
              "
              :disabled="!(emailModeObj.email && emailModeObj.password)"
              class="login_btn"
              @click="loginByAccount()"
            >
              登 录
            </button>
          </div>
        </div>
        <!-- 微信一键登录 -->
        <div
          class="wxlogin-block"
          v-show="wxLoginShow && !forgetShow && !resetShow"
        >
          <div class="taskTab font-18 color-3 font-6w">
            使用微信扫一扫登录
          </div>
          <div class="text-R des_img">
            <img
              src="../assets/images/login/img-loginchange-code.png"
              @click="wxLoginShow = false"
              class="pointer"
            />
          </div>
          <div>
            <div id="wxLoginWrap"></div>
          </div>
          <div class="text-C font-14 forgetPw"></div>
          <div class="wxTab">
            <div
              class="wxTabItem pointer font-16"
              @click="
                wxLoginShow = false;
                loginByAccountShow = false;
              "
            >
              短信登录
            </div>
            <div class="wxLine"></div>
            <div
              class="wxTabItem  pointer font-16"
              @click="
                wxLoginShow = false;
                loginByAccountShow = true;
              "
            >
              密码登录
            </div>
          </div>
        </div>
        <!-- 忘记密码 第一步 -->

        <div class="register_form" v-show="forgetShow && !wxLoginShow">
          <div class="taskTab font-18 color-3 font-6w">
            身份验证
          </div>
          <div class="text-R des_img"></div>
          <div class="register_div">
            <div class="login_input pointer">
              <el-input
							  @input="formValidate('mobilePhone1')"
                auto-complete="new-password"
                autocomplete="new-password"
                :disabled="forMobilePhoneDisabled"
                maxlength="20"
                v-model="forgetModeObj.mobilePhone"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </div>
            <div class="password validcode login_input pointer">
              <el-input
                auto-complete="new-password"
                autocomplete="new-password"
                maxlength="6"
                v-model="forgetModeObj.validCode"
                placeholder="请输入短信验证码"
              ></el-input>
              <button :class="jyPhone2?'bs':''"
                class="valid_btn pointer font-16"
                @click="forsendValidClick"
              >
                {{ forSendValidBtnText }}
              </button>
            </div>
            <div class="text-C font-14 forgetPw"></div>

            <div class="userAgreement1  font-14"></div>
            <button
              :class="
                forgetModeObj.mobilePhone && forgetModeObj.validCode
                  ? ''
                  : 'disabled-btn'
              "
              :disabled="
                !(forgetModeObj.mobilePhone && forgetModeObj.validCode)
              "
              class="login_btn"
              @click="NextForgetPW()"
            >
              下一步
            </button>
          </div>
        </div>
        <!-- 忘记密码 第二步-->
        <div class="register_form RestFrom" v-show="resetShow && !wxLoginShow">
          <div class="taskTab font-18 color-3 font-6w">
            重置密码
          </div>
          <div class="text-R des_img"></div>
          <div class="register_div">
            <div class="login_input pointer">
              <el-input
                auto-complete="new-password"
                autocomplete="new-password"
                maxlength="50"
                v-model="ResetModeObj.password"
                placeholder="输入新密码"
                clearable
                show-password
              ></el-input>
            </div>
            <div class="login_input password pointer">
              <el-input
                auto-complete="new-password"
                autocomplete="new-password"
                type="password"
                maxlength="50"
                v-model="ResetModeObj.password1"
                placeholder="请确认新密码"
                clearable
                show-password
              ></el-input>
            </div>
            <div class="text-C font-14 forgetPw"></div>
            <div class="userAgreement1  font-14"></div>
          
            <button
              :class="
                ResetModeObj.password && ResetModeObj.password1
                  ? ''
                  : 'disabled-btn'
              "
              :disabled="!(ResetModeObj.password && ResetModeObj.password1)"
              class="login_btn"
              @click="finishSetPassword()"
            >
              完 成
            </button>
          </div>
        </div>
      </div>
    </div>

    <userProtocol
      v-if="isProtocolView"
      @close="closeProtocolView"
      @agreeB="agreeBtn"
    ></userProtocol>
    <userProtocol1
      v-if="isProtocolView1"
      @close="closeProtocolView1"
      @agreeB="agreeBtn1"
    ></userProtocol1>
  </div>
</template>
<script>
import userProtocol from "./user/userProtocol"; // 用户购买协议
import userProtocol1 from "./user/userProtocol1"; // 用户购买协议
export default {
  name: "externalLogin",
  components: { userProtocol, userProtocol1 },
  data() {
    return {
			jyPhone2:false,
			jyPhone1:false,
      timerFo: null,
      timer: null,
      resetShow: false,
      forgetShow: false,
      userAgreementCheck: true,
      isProtocolView: false,
      isProtocolView1: false,
      emailList: [],
      mobilePhoneDisabled: false,
      loginByAccountShow: false, // 默认显示账号密码登录
      sendValidBtnText: "发送验证码",

      // 账号密码
      emailModeObj: {
        email: "",
        password: ""
      },
      // 手机号验证码
      phoneModeObj: {
        mobilePhone: "",
        validCode: ""
      },
      //重置密码第一步
      forgetModeObj: {
        mobilePhone: "",
        validCode: ""
      },
      //重置密码第二步
      ResetModeObj: {
        mobilePhone: "",
        password: "",
        password1: ""
      },
      wxLoginShow: false,
      loading: false,

      forSendValidBtnText: "发送验证码",
      forMobilePhoneDisabled: false
    };
  },
  mounted() {
    this.initQrCode();
  },
  destroyed() {
    clearTimeout(this.timer);
    this.timer = null;

    clearTimeout(this.timerFo);
    this.timerFo = null;
  },
  methods: {
		formValidate(val){
			if(val=='mobilePhone'){
				
				let flag = this.emptyValidate(this.phoneModeObj.mobilePhone);
				let flag1 = this.checkPhone(this.phoneModeObj.mobilePhone);
				if (!flag || !flag1) {
				  this.jyPhone1 = false
				  return;
				}
				if (this.phoneModeObj.mobilePhone.length < 6) {
				   this.jyPhone1 = false
				  return;
				}
				 this.jyPhone1 = true
		
			}else{
				let flag2 = this.emptyValidate(this.forgetModeObj.mobilePhone);
				let flag3 = this.checkPhone(this.forgetModeObj.mobilePhone);
				if (!flag2 || !flag3) {
				  this.jyPhone2 = false
				  return;
				}
				if (this.forgetModeObj.mobilePhone.length < 6) {
				   this.jyPhone2 = false
				  return;
				}
				 this.jyPhone2 = true
				 
				
			}
			
		},
    clickBox() {
      this.$message({
        type: "warning",
        message: "您需要同意协议才可登录"
      });
      this.userAgreementCheck = true;
    },
    chineseValidator(val) {
      let re = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
      if (!re.test(val) && val.length >= 6) {
        return true;
      } else {
        return false;
      }
    },
    emptyValidate(val) {
      if (val) {
        return !val.match(/^[ ]*$/);
      } else {
        return false;
      }
    },
    checkPhone(val) {
      return /^\d*$/.test(val);
    },
    coloseDia() {
      this.$emit("closeClick", true);
    },
    openResetShow() {
      this.resetShow = !this.resetShow;
      if (!this.resetShow) {
        this.forgetShow = true;
      }
    },
    openForgetShow() {
      this.forgetShow = !this.forgetShow;
    },
    // 查看协议
    openProtocol1() {
      this.isProtocolView1 = true;
    },
    // 关闭协议
    closeProtocolView1() {
      this.isProtocolView1 = false;
    },
    agreeBtn() {
      this.isProtocolView = false;
      this.userAgreementCheck = true;
    },
    agreeBtn1() {
      this.isProtocolView1 = false;
      this.userAgreementCheck = true;
    },
    // 查看协议
    openProtocol() {
      this.isProtocolView = true;
    },
    // 关闭协议
    closeProtocolView() {
      this.isProtocolView = false;
    },
    // 初始化登录二维码
    initQrCode() {
      console.log("initQrCode===>", `${this.WITSBOX_ENV_PARAM.loginPage}`);
      new WxLogin({
        self_redirect: false,
        id: "wxLoginWrap",
        appid: "wxa066f5ef8ca964db",
        scope: "snsapi_login",
        redirect_uri:
          "https%3A%2F%2Fwww.dailyedu.com%2Fstudent-pc%2F%23%2Flearning%2Fmiddle1",
        state: Math.ceil(Math.random() * 1000),
        style: "",
        href:
          "data:text/css;base64,aWZyYW1le3dpZHRoOiAxMzBweDsgaGVpZ2h0OiAxNDBweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAxMjBweDttYXJnaW4tdG9wOjA7Ym9yZGVyOm5vbmU7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTogbm9uZTt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTpub25lO30KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30g"
      });
    },
    // 记住密码
    rememberPassword() {
      localStorage.setItem("loginForm", JSON.stringify(this.emailModeObj));
    },
    // 计时器事件
    timeDown(n) {
      if (n <= 0) {
        this.timer && clearTimeout(this.timer);

        this.mobilePhoneDisabled = false;
        this.sendValidBtnText = "发送验证码";

        return;
      }
      this.timer = setTimeout(() => {
        n = n - 1;
        this.sendValidBtnText = "" + n + "s后 重新获取";
        this.timeDown(n);
      }, 1000);
    },
    // 计时器事件
    timeDownFo(n) {
      if (n <= 0) {
        this.timerFo && clearTimeout(this.timerFo);
        this.forMobilePhoneDisabled = false;
        this.forSendValidBtnText = "发送验证码";
        return;
      }
      this.timerFo = setTimeout(() => {
        n = n - 1;
        this.forSendValidBtnText = "" + n + "s后 重新获取";
        this.timeDownFo(n);
      }, 1000);
    },
    // 发送验证码事件
    forsendValidClick() {
      if (this.forMobilePhoneDisabled) {
        return;
      }
      let flag = this.emptyValidate(this.forgetModeObj.mobilePhone);
      let flag1 = this.checkPhone(this.forgetModeObj.mobilePhone);
      if (!flag || !flag1) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号码"
        });
        return;
      }
      if (this.forgetModeObj.mobilePhone.length < 6) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号码"
        });
        return;
      }
      this.request
        .get(
          `${this.WITSBOX_ENV_PARAM.baseUrl}/user/validCode/${
            this.forgetModeObj.mobilePhone
          }?tem=${new Date().getTime()}`
        )
        .then(res => {
          if (res && res.success) {
            this.forMobilePhoneDisabled = true;
            this.timeDownFo(60);
          } else {
            // 发送验证码超过5次的提示
            this.global.webToast(res.message);
          }
        });
    },
    // 发送验证码事件
    sendValidClick() {
      if (this.mobilePhoneDisabled) {
        return;
      }
      let flag = this.emptyValidate(this.phoneModeObj.mobilePhone);
      let flag1 = this.checkPhone(this.phoneModeObj.mobilePhone);
      if (!flag || !flag1) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号码"
        });
        return;
      }
      if (this.phoneModeObj.mobilePhone.length < 6) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号码"
        });
        return;
      }
      this.request
        .get(
          `${this.WITSBOX_ENV_PARAM.baseUrl}/user/validCode/${
            this.phoneModeObj.mobilePhone
          }?tem=${new Date().getTime()}`
        )
        .then(res => {
          if (res && res.success) {
            this.mobilePhoneDisabled = true;
            this.timeDown(60);
          } else {
            // 发送验证码超过5次的提示
            this.global.webToast(res.message);
          }
        });
    },
    finishSetPassword() {
      let flag = this.emptyValidate(this.ResetModeObj.password1);
      let flag1 = this.emptyValidate(this.ResetModeObj.password);
      if (!flag) {
        this.$message({
          type: "error",
          message: "请输入正确的密码"
        });
        return;
      }
      if (!flag1) {
        this.$message({
          type: "error",
          message: "请输入正确的密码"
        });
        return;
      }

      if (this.ResetModeObj.password1 != this.ResetModeObj.password) {
        this.$message({
          type: "error",
          message: "两次密码输入不一致"
        });
        return;
      }

      let flag3 = this.chineseValidator(this.ResetModeObj.password);
      if (!flag3) {
        this.$message({
          type: "error",
          message: "请输入6-50个英文字母、数字、特殊字符"
        });
        return;
      }

      let _obj = {};
      _obj.mobilePhone = this.ResetModeObj.mobilePhone;
      _obj.password = this.ResetModeObj.password;
      this.request
        .put(this.WITSBOX_ENV_PARAM.baseUrl + "/user/password", _obj)
        .then(res => {
          if (res.success) {
            localStorage.removeItem("commonToken");
            this.$message({
              type: "success",
              message: "修改成功 且自动返回密码登录弹框"
            });
            this.ResetModeObj = {
              mobilePhone: "",
              password: "",
              password1: ""
            };
            this.forgetModeObj = { mobilePhone: "", validCode: "" };
            this.emailModeObj = { email: "", password: "" };
            this.phoneModeObj = { mobilePhone: "", validCode: "" };
            this.forgetShow = false;
            this.resetShow = false;
            this.loginByAccountShow = true;
            this.$forceUpdate();
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
    },
    NextForgetPW() {
      this.timeDownFo(-1);
      let flag = this.emptyValidate(this.forgetModeObj.mobilePhone);
      let flag1 = this.emptyValidate(this.forgetModeObj.validCode);
      if (!flag) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号码"
        });
        return;
      }
      if (!flag1) {
        this.$message({
          type: "error",
          message: "请输入正确的验证码"
        });
        return;
      }
      this.request
        .post(
          this.WITSBOX_ENV_PARAM.baseUrl + "/user/validCode",
          this.forgetModeObj
        )
        .then(res => {
          if (res.dataModel == 1) {
            this.$message({
              type: "error",
              message: "验证码错误"
            });
          } else if (res.dataModel == -1) {
            this.$message({
              type: "error",
              message: "验证码失效"
            });
          } else if (res.dataModel == 0) {
            this.global.createCommonToken();
            this.ResetModeObj = {
              mobilePhone: this.forgetModeObj.mobilePhone,
              password: "",
              password1: ""
            };
            this.forgetModeObj = { mobilePhone: "", validCode: "" };
            this.forgetShow = false;
            this.resetShow = true;

            this.$forceUpdate();
          }
        });
    },
    // 账号密码登录
    loginByAccount() {
		  localStorage.removeItem('student-learning-data')
      let flag = this.emptyValidate(this.emailModeObj.email);
      let flag1 = this.emptyValidate(this.emailModeObj.password);
      if (!flag) {
        this.$message({
          type: "error",
          message: "请输入正确的账号/邮箱/手机号"
        });
        return;
      }
      if (!flag1) {
        this.$message({
          type: "error",
          message: "请输入正确的密码"
        });
        return;
      }
      this.rememberPassword();
      this.emailList = [];
      let url = `${this.WITSBOX_ENV_PARAM.baseUrl}/user/web/stuLogin`;
      this.request.post(url, this.emailModeObj).then(res => {
        if (res.success) {
          if (res.dataModel.userList && res.dataModel.userList.length) {
            let dataModel = res.dataModel.userList;
            dataModel.forEach(item => {
              let obj = {};
              obj.userId = item.userId;
              obj.name = item.email;
              this.emailList.push(obj);
            });
          } else {
            this.schoolLogin(res);
          }
        } else {
          this.$message({
            type: "warning",
            message: res.message
          });
        }
      });
    },
    // 手机号验证码登录
    loginByMobile() {
		  localStorage.removeItem('student-learning-data')
      this.timeDown(-1);
      let flag = this.emptyValidate(this.phoneModeObj.mobilePhone);
      let flag1 = this.emptyValidate(this.phoneModeObj.validCode);
      if (!flag) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号码"
        });
        return;
      }
      if (!flag1) {
        this.$message({
          type: "error",
          message: "请输入正确的验证码"
        });
        return;
      }

      this.emailList = [];
      let url = `${this.WITSBOX_ENV_PARAM.baseUrl}/user/userLogin/phone`;
      this.request.post(url, this.phoneModeObj).then(res => {
        if (res.success) {
          if (res.dataModel.userList && res.dataModel.userList.length) {
            let dataModel = res.dataModel.userList;
            dataModel.forEach(item => {
              let obj = {};
              obj.userId = item.userId;
              obj.name = item.email;
              this.emailList.push(obj);
            });
          } else {
            this.schoolLogin(res);
          }
        } else {
          if (res.code == "10020") {
            this.global.webToast("Invalid code");
          } else {
            this.global.webToast(res.message);
          }
        }
      });
    },
    schoolLogin(result) {
      localStorage.setItem(
        "commonToken",
        result.dataModel && result.dataModel.token
      );
      let userInfo = result.dataModel && result.dataModel.user;
      localStorage.setItem("userId", userInfo.userId);
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      // roleType 0：学员 1：老师 2：职员
      let url = `${
        this.WITSBOX_ENV_PARAM.baseUrl
      }/project/userInfo?tem=${new Date().getTime()}`;
      this.request.get(url).then(res => {
        if (res.success) {
					localStorage.setItem('keyandsecret',JSON.stringify(res.dataModel && res.dataModel.keyAndsecret))
          localStorage.setItem(
            "schoolIdList",
            JSON.stringify(res.dataModel && res.dataModel.schoolIdList)
          );
          localStorage.setItem(
            "projectIdList",
            JSON.stringify(res.dataModel && res.dataModel.projectIdList)
          );

          setTimeout(() => {
            this.loading = false;
            localStorage.removeItem("windowReload");
            this.toPage();
          }, 500);
        } else {
          this.global.webToast(res.message);
        }
      });
    },

    loginJump() {
      let url = `${
        this.WITSBOX_ENV_PARAM.baseUrl
      }/project/userInfo?tem=${new Date().getTime()}`;
      this.request.get(url).then(res => {
        if (res.success) {
					localStorage.setItem('keyandsecret',JSON.stringify(res.dataModel && res.dataModel.keyAndsecret))
          localStorage.setItem(
            "schoolIdList",
            JSON.stringify(res.dataModel && res.dataModel.schoolIdList)
          );
          localStorage.setItem(
            "projectIdList",
            JSON.stringify(res.dataModel && res.dataModel.projectIdList)
          );

          setTimeout(() => {
            this.loading = false;
            localStorage.removeItem("windowReload");
            this.toPage();
          }, 500);
        } else {
          this.global.webToast(res.message);
        }
      });
    },
    toPage() {
      this.coloseDia();
      const userId = localStorage.getItem("userId");
      if (userId) {
        this.request
          .get(`${this.WITSBOX_ENV_PARAM.baseUrl}/project/${userId}/courseList`)
          .then(res => {
            this.loading = false;
            if (res.success) {
              let data = res.dataModel || [];
							localStorage.removeItem('freeRecommendCourse');
							localStorage.removeItem('MCGoodsList');
							localStorage.removeItem('videoList');
							localStorage.removeItem('readPlanList');
							localStorage.removeItem('OrtalNEW');
							localStorage.removeItem('studyThemeList');
              if (data.length == 0) {
                window.location.href = `${
                  this.WITSBOX_ENV_PARAM.loginPage
                }#/learning/index`;
                window.location.reload();
              } else {
                window.location.href = `${
                  this.WITSBOX_ENV_PARAM.loginPage
                }#/study/center`;
                window.location.reload();
              }
            } else {
              if (res.code != "10019") {
                this.Toast(res.message);
              }
            }
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.des_img {
  height: 1.6rem;
  margin-bottom: 0.16rem;
  img {
    height: 100%;
  }
}
.wxTab {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  display: flex;
  margin: 0px auto;
  justify-content: center;

  .wxTabItem {
    height: 0.8rem;

    line-height: 0.8rem;
    color: #1f85fc;
    position: relative;
    width: 4.2rem;
  }
  .wxLine {
    width: 1px;
    height: 0.8rem;
    background: #ebeff9;
  }
}
.taskTab {
  width: 100%;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  display: flex;
  margin: 0px auto;
  justify-content: center;

  .taskTabItem {
    height: 2.4rem;
    font-size: 0.72rem;
    line-height: 2.4rem;
    color: #666666;
    position: relative;
    width: 4.2rem;
  }

  .taskTabActive {
    color: #1f85fc;
    font-family: PingFang SC;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .tabLine {
    width: 1.6rem;
    height: 0.16rem;
    position: absolute;
    background: #2141a8;
    bottom: 0.24rem;
  }
}
/deep/ .RestFrom .el-input--suffix .el-input__inner {
    padding-right: 50px;
}
/deep/ .el-input__inner:hover {
  border: 1px solid #1f85fc;
}
/deep/ .el-input__inner {
  font-size: 0.64rem;
  height: 1.92rem;
  line-height: 1.92rem;
  border: 1px solid #999999;
  border-radius: 0.96rem;
  padding-left: 0.8rem;
}
/deep/ .el-input__suffix {
  top: 0.08rem;
}
@media screen and (min-width: 1px) and (max-width: 1445px) {
  /deep/ .el-input__suffix {
    top: -1px;
  }
}
/deep/ .el-input__inner:focus {
  border: 1px solid #1f85fc;
}
#wxLoginWrap {
  width: 140px;
  height: 140px;
  margin: 0 auto;
  margin-top: 1.8rem;
  /deep/ iframe {
    width: 120px;
    height: 120px;
  }
}
.forgetPw {
  margin-top: 1.2rem;
  height: 0.6rem;
  line-height: 0.6rem;
  font-weight: 400;
}

.userAgreement1 {
  height: 1.25rem;
  margin-top: 1.04rem;

  .van-checkbox__icon {
    position: absolute;

    .van-icon {
      border-color: #1f85fc;
      border-radius: 2.5px;
    }
  }

  .van-checkbox__icon--checked {
    .van-icon {
      background: #1f85fc;
    }
  }

  .van-checkbox__label {
    margin-left: 30px;
    font-size: 12px;
    color: #999999;
  }

  .protocol {
    color: #1f85fc;
  }
}

#externalLogin {
  .other-login {
    color: #666;
    font-size: 14px;
    text-align: right;
    img {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      margin-right: 10px;
      cursor: pointer;
      &:hover {
        box-shadow: 1px 2px 10px 1px rgba(0, 0, 0, 0.3);
      }
    }
  }
  .wxlogin-block {
    text-align: center;

    font-size: 14px;
    color: #666;
    #wxLoginWrap {
      background: url("./user/img/qr-border.png") 0 0 / 140px no-repeat;
      padding: 5px;
    }
    iframe {
      width: 125px;
      height: 123px;
    }
    .wximg {
      text-align: left;
      .imgdiv {
        display: flex;
        align-items: center;
        color: #333;
        img {
          width: 50px;
          height: 50px;
          border: 3px solid #fff;
          box-shadow: 0 0 0 1px #dedede;
          border-radius: 4px;
          cursor: pointer;
          &:hover {
            box-shadow: 0 0 0 1px #4796dd;
          }
          margin-right: 10px;
        }
      }
      .imgtips {
        margin-top: 10px;
      }
    }
  }
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  .content {
    background: #101f1e;
    width: 100%;
    height: 100%;
    opacity: 0.3;
  }

  .container {
    position: absolute;
    width: 19.5rem;
    height: 17.6rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .register_login_right {
      position: relative;
      background: #fff;
      padding: 0 0.4rem;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      .back1 {
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        left: 0.48rem;
        top: 0.88rem;
      }
      .close1 {
        width: 0.8rem;
        height: 0.8rem;
        position: absolute;
        right: 0.48rem;
        top: 0.88rem;
      }

      .register_form {
        .register_div {
          padding: 0 1.2rem;
          .password {
            position: relative;
            margin-top: 1.28rem;
          }
          .validcode {
            position: relative;
          }

          .login_btn {
            border: 0px solid;
            width: 100%;
            background: #1f85fc;
            color: #fff;
            font-size: 0.72rem;
            text-align: center;
            border-radius: 0.96rem;
            height: 1.92rem;
            line-height: 1.92rem;
            cursor: pointer;
            font-weight: bold;
            margin-top: 0.72rem;
          }
          .disabled-btn {
            opacity: 0.3;
          }
        }
      }

      .valid_btn {
        position: absolute;
        right: 0.8rem;
        top: 0.5rem;
        color: #666666;
        background: transparent;
        border: none;
      }
			.bs{
				 color: #1f85fc;
			}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/externalLogin.vue